import { filter, map, mapObjIndexed, pipe, pluck, propEq, uniq } from "ramda";

import {
  ILocation,
  IBrandGroup,
  ISalesForecast,
  ISalesSummary,
} from "types/account";

const isolateBrands = (locations: ILocation[]): string[] => {
  return uniq(pluck("brandName", locations));
};

function isolateBrandStores(locations: ILocation[]) {
  return (brand: string): IBrandGroup => {
    const brandStores: ILocation[] = filter(
      propEq("brandName", brand),
      locations
    );

    return {
      brand,
      brandId: brandStores[0].brandId,
      stores: brandStores,
    };
  };
}

function sortEntitiesByBrand(locations: ILocation[]): IBrandGroup[] {
  return pipe(isolateBrands, map(isolateBrandStores(locations)))(locations);
}

interface ISalesSummaryResponse {
  date: string;
  netSalesAmount: string;
  grossSalesAmount: string;
}

interface ISalesForecastResponse {
  totalNetSales: string;
  totalGrossSales: string;
  daily: ISalesSummaryResponse[];
}

const salesForecastToNumbers = ({
  totalNetSales,
  totalGrossSales,
  daily,
}: ISalesForecastResponse): ISalesForecast => {
  return {
    totalNetSales: parseFloat(totalNetSales),
    totalGrossSales: parseFloat(totalGrossSales),
    daily: map<ISalesSummaryResponse, ISalesSummary>(
      (thisDay) =>
        mapObjIndexed<string, string | number>((v: string, k: string) => {
          if (k !== "date") {
            return parseFloat(v);
          }
          return v;
        }, thisDay) as unknown as ISalesSummary,
      daily
    ),
  };
};

export { salesForecastToNumbers, sortEntitiesByBrand, ISalesForecastResponse };
